import { Trans } from '@lingui/macro';
import { Button } from '@pocketlaw/tetris';
import { Link } from 'react-router-dom';
import { useDisplayUpgrade } from './useDisplayUpgrade';
function UpgradeButton() {
    const shouldDisplay = useDisplayUpgrade();
    if (!shouldDisplay) {
        return null;
    }
    return (<Button as={Link} to="/plans" appearance="ghost" size="medium">
      <Trans>Upgrade</Trans>
    </Button>);
}
export default UpgradeButton;
